import React, {Fragment} from 'react';
import {Icon} from 'antd';
import './index.less';
import Add from './Icons/add.svg';
import AddText from './Icons/add-text.svg';
import Assessment from './Icons/Assessment.svg';
import Act from './Icons/act.svg';
import Cbt from './Icons/cbt.svg';
import Back from './Icons/back.svg';
import Calendar from './Icons/calender.svg';
import Call from './Icons/call.svg';
import Chat from './Icons/chat.svg';
import Check from './Icons/check-box-01.svg';
import Claim from './Icons/claim.svg';
import ClientInfo from './Icons/client-info.svg';
import ClientInsight from './Icons/client-insight.svg';
import ClientPortal from './Icons/client-portal.svg';
import ClientSubscription from './Icons/client-subscription.svg';
import Clinician from './Icons/clinician.svg';
import Close from './Icons/close.svg';
import Copy from './Icons/copy.svg';
import CreditCard from './Icons/credit-card.svg';
import Download from './Icons/download.svg';
import Email from './Icons/email.svg';
import Enrollment from './Icons/enrollment.svg';
import Export from './Icons/export.svg';
import Family from './Icons/family.svg';
import Help from './Icons/help.svg';
import History from './Icons/histroy.svg';
import Homework from './Icons/Homework.svg';
import HomeworkInnerTab from './Icons/Homework-inner-tab.svg';
import InfoSetting from './Icons/Info_settings.svg';
import Insight from './Icons/Insight.svg';
import Insurance from './Icons/insurance.svg';
import Invite from './Icons/invite.svg';
import Invoice from './Icons/invoice.svg';
import Link from './Icons/link.svg';
import Marriage from './Icons/marriage.svg';
import NotesBilling from './Icons/Notes_Billing.svg';
import OnlinePayment from './Icons/online-payment.svg';
import Payer from './Icons/payer.svg';
import Payment from './Icons/Payment.svg';
import Print from './Icons/Print.svg';
import Product from './Icons/product.svg';
import Reference from './Icons/reference.svg';
import Reorder from './Icons/reorder.svg';
import Search from './Icons/search.svg';
import Send from './Icons/send.svg';
import SentInvite from './Icons/sent-invite.svg';
import Services from './Icons/services.svg';
import Setting from './Icons/setting.svg';
import SortAtoz from './Icons/sort_atoz.svg';
import SortZtoa from './Icons/sort_ztoa.svg';
import Tick from './Icons/tick.svg';
import Time from './Icons/time.svg';
import Transaction from './Icons/transaction.svg';
import Upload from './Icons/upload.svg';
import VideoSession from './Icons/video-session.svg';
import VideoTutorial from './Icons/video-tutorial.svg';
import VideoTutorial_1 from './Icons/video_tutorial-01.svg';
import videoCall from './Icons/video-call.svg';
import View from './Icons/view.svg';
import Work from './Icons/work.svg';
import Exercise from './Icons/Exercise-old.svg';
import NoData from './Icons/Nodata.svg';
import Statimg from './Icons/statistics.svg';
import Measureimg from './Icons/predictive.svg';
import Practiceimg from './Icons/Practice_idea.svg';
import Meditationimg from './Icons/Meditation.svg';
import Groupimg from './Icons/group.svg';
import Resultimg from './Icons/result.svg';
import NoClient from './Icons/NoClient.svg';
import Coverage from './Icons/coverage.svg';
import Upgrade from './Icons/upgrade.svg';
import Billing from './Icons/billing.svg';
import BillingInsurance from './Icons/billing-insurance.svg';
import Assign from './Icons/assign.svg';
import Insights from './Icons/insights.svg';
import PracticeSetting from './Icons/practice-setting.svg';
import PracticeDetails from './Icons/practice-details.svg';
import BillingService from './Icons/billing-service.svg';
import Documents from './Icons/documents.svg';
import Notifications from './Icons/notifications.svg';
import NotesForms from './Icons/notes-forms.svg';
import InsurancePayers from './Icons/insurance-payers.svg';
import Administration from './Icons/administration.svg';
import Subscription from './Icons/subscription.svg';
import TeamMembers from './Icons/team-members.svg';
import AccountActivity from './Icons/account-activity.svg';
import Results from './Icons/results.svg';

const BTIcon = (props) => {
  switch (props.type) {
    case 'add':
      return <Icon {...props} component={Add} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'add-text':
      return <Icon {...props} component={AddText} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'assessment':
      return <Icon {...props} component={Assessment} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;

    case 'back':
      return <Icon {...props} component={Back} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'right':
      return <Icon {...props} type={"right"} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'calendar':
      return <Icon {...props} component={Calendar} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'call':
      return <Icon {...props} component={Call} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'chat':
      return <Icon {...props} component={Chat} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'check':
      return <Icon {...props} component={Check} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'claim':
      return <Icon {...props} component={Claim} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'clientInfo':
      return <Icon {...props} component={ClientInfo} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'clientInsight':
      return <Icon {...props} component={ClientInsight} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'clientPortal':
      return <Icon {...props} component={ClientPortal} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'clientSubscription':
      return <Icon {...props} component={ClientSubscription} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'clinician':
      return <Icon {...props} component={Clinician} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'close':
      return <Icon {...props} component={Close} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'copy':
      return <Icon {...props} component={Copy} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'coverage':
      return <Icon {...props} component={Coverage} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'creditCard':
      return <Icon {...props} component={CreditCard} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'delete':
      return <Icon {...props} type={"delete"} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'download':
      return <Icon {...props} component={Download} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'edit':
      return <Icon {...props} type={"edit"} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'email':
      return <Icon {...props} component={Email} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'enrollment':
      return <Icon {...props} component={Enrollment} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'export':
      return <Icon {...props} component={Export} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'family':
      return <Icon {...props} component={Family} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'help':
      return <Icon {...props} component={Help} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'history':
      return <Icon {...props} component={History} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'homework':
      return <Icon {...props} component={Homework} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'homeworkInnerTab':
      return <Icon {...props} component={HomeworkInnerTab} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'infoSetting':
      return <Icon {...props} component={InfoSetting} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'insight':
      return <Icon {...props} component={Insight} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'insurance':
      return <Icon {...props} component={Insurance} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'invite':
      return <Icon {...props} component={Invite} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'invoice':
      return <Icon {...props} component={Invoice} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'link':
      return <Icon {...props} component={Link} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'marriage':
      return <Icon {...props} component={Marriage} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'notesBilling':
      return <Icon {...props} component={NotesBilling} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'onlinePayments':
      return <Icon {...props} component={OnlinePayment} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'payer':
      return <Icon {...props} component={Payer} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'payment':
      return <Icon {...props} component={Payment} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'print':
      return <Icon {...props} component={Print} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'product':
      return <Icon {...props} component={Product} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'reference':
      return <Icon {...props} component={Reference} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'reorder':
      return <Icon {...props} component={Reorder} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'send':
      return <Icon {...props} component={Send} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'search':
      return <Icon {...props} component={Search} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'sentInvite':
      return <Icon {...props} component={SentInvite} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'services':
      return <Icon {...props} component={Services} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'sort_atoz':
      return <Icon {...props} component={SortAtoz} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'sort_ztoa':
      return <Icon {...props} component={SortZtoa} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'tick':
      return <Icon {...props} component={Tick} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'time':
      return <Icon {...props} component={Time} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'transaction':
      return <Icon {...props} component={Transaction} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'upload':
      return <Icon {...props} component={Upload} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'videoTutorial':
      return <Icon {...props} component={VideoTutorial} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'videoTutorial_1':
      return <Icon {...props} component={VideoTutorial_1} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'videoSession':
      return <Icon {...props} component={VideoSession} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'view':
      return <Icon {...props} component={View} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'videoCall':
      return <Icon {...props} component={videoCall} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'videoCamera':
      return <Icon {...props} type={"video-camera"} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'work':
      return <Icon {...props} component={Work} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'setting':
      return <Icon {...props} component={Setting} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'exercise':
      return <Icon {...props} component={Exercise} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'Entries':
      return <Icon {...props} component={NoData} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'Statistics':
      return <Icon {...props} component={Statimg} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'Measures':
      return <Icon {...props} component={Measureimg} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'Exercises':
      return <Icon {...props} component={Exercise} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'Practice':
      return <Icon {...props} component={Practiceimg} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'Meditations':
      return <Icon {...props} component={Meditationimg} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'Group':
      return <Icon {...props} component={Groupimg} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'Result':
      return <Icon {...props} component={Resultimg} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'Payment':
      return <Icon {...props} component={Payment} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'NoClient':
      return <Icon {...props} component={NoClient} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'upgrade':
      return <Icon {...props} component={Upgrade} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'billing':
      return <Icon {...props} component={Billing} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'billingInsurance':
      return <Icon {...props} component={BillingInsurance} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'assign':
      return <Icon {...props} component={Assign} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'insights':
      return <Icon {...props} component={Insights} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'practiceSetting':
      return <Icon {...props} component={PracticeSetting} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'practiceDetails':
      return <Icon {...props} component={PracticeDetails} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'billingService':
      return <Icon {...props} component={BillingService} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'documents':
      return <Icon {...props} component={Documents} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'notifications':
      return <Icon {...props} component={Notifications} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'notesForms':
      return <Icon {...props} component={NotesForms} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'clientPortal':
      return <Icon {...props} component={ClientPortal} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'insurancePayers':
      return <Icon {...props} component={InsurancePayers} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'administration':
      return <Icon {...props} component={Administration} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'subscription':
      return <Icon {...props} component={Subscription} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'teamMembers':
      return <Icon {...props} component={TeamMembers} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'accountActivity':
      return <Icon {...props} component={AccountActivity} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'clientPortal':
      return <Icon {...props} component={ClientPortal} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'results':
      return <Icon {...props} component={Results} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'act':
      return <Icon {...props} component={Act} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    case 'cbt':
      return <Icon {...props} component={Cbt} onClick={props.onClick}
                   className={`svg-icons ${props.className || ''}`}/>;
    default:
      return <Fragment/>;
  }
};
export default BTIcon;
